import Api from '@/apis/businessApi'
import Store from '@/store'
import i18n from '@/i18n'

export default {
  async getOverview () {
    return Api()
      .get('/v1/customers')
      .then(async function (response) {
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.LoadingCustomersErrorMessage'),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async create (customer) {
    return Api()
      .post('/v1/customers', {
        uid: '00000000-0000-0000-0000-000000000000',
        name: customer.name,
        vatNumber: customer.vatNumber,
        address: customer.address,
        postalCode: customer.postalCode,
        city: customer.city,
        country: customer.country,
        contactName: customer.contactName,
        contactEmail: customer.contactEmail,
        contactPhone: customer.contactPhone,
      })
      .then(async function (response) {
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.CreateCustomerSuccessMessage', [customer.name]),
          color: 'success',
        })
        return { success: true, value: response.data }
      })
      .catch(async function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        await Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.CreateCustomerErrorMessage', [customer.name]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
  async update (customer) {
    var updateCustomer = {
      uid: customer.uid,
      name: customer.name,
      vatNumber: customer.vatNumber,
      address: customer.address,
      postalCode: customer.postalCode,
      city: customer.city,
      country: customer.country,
      contactName: customer.contactName,
      contactEmail: customer.contactEmail,
      contactPhone: customer.contactPhone,
    }
    return Api()
      .put('/v1/customers', updateCustomer)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.UpdateCustomerSuccessMessage', [updateCustomer.name]),
          color: 'success',
        })
        return { success: true, value: updateCustomer }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.UpdateCustomerErrorMessage', [updateCustomer.name]),
          color: 'error',
        })
        console.error(error) // todo what to do?
        return { success: false }
      })
  },
  async delete (customerUid) {
    return Api()
      .delete('/v1/customers/' + customerUid)
      .then(function (response) {
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.DeleteCustomerSuccessMessage', [customerUid.substr(0, 6)]),
          color: 'success',
        })
        return { success: true }
      })
      .catch(function (error) {
        if (error.response.status === 400) {
          return { success: false, badRequestReasons: error.response.data }
        }
        Store.dispatch('SetSnackBarMessage', {
          message: i18n.t('Services.Customer.Messages.DeleteCustomerErrorMessage', [customerUid.substr(0, 6)]),
          color: 'error',
        })
        console.error(error)
        return { success: false }
      })
  },
}
